import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";

export const sendOtpApi = createAsyncThunk(
  "user/sendOtp",
  async (identifierData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/users/send-otp", identifierData);
      return response.data;
    } catch (error) {
      console.error("SendOtp API error:", error);
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.message || "Failed to send OTP",
        );
      }
      return rejectWithValue("Failed to send OTP");
    }
  },
);
